/**
 * Reviews Banner
 */
const reviewsBanner = $('#reviewsBanner');

if (reviewsBanner.length) {
    reviewsBanner.slick({
        dots: false,
        arrows: false,
        adaptiveHeight: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000
    });
}

function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}
document.addEventListener('scroll', function () {
    //- change Reviews Banner Component to fixed position when arrived to top
    const reviewsComponent = $('#reviewsBanner');

    if (reviewsComponent.length) {
        const bannerComponent = document.querySelector('.reviewsBanner');
        const topElement = document.querySelector('#viewportDetector');

        let bannerComponentHeight = bannerComponent.clientHeight + 30 + 'px';

        // console.log('bannerComponent ' + isInViewport(bannerComponent));
        // console.log('topElement ' + isInViewport(topElement));
        // console.log('bannerComponentHeight ' + bannerComponentHeight);

        if (isInViewport(bannerComponent) == false) {
            bannerComponent.classList.add('fixed');

            document.documentElement.style.setProperty('--iconMarginTop', bannerComponentHeight);
        }

        if (isInViewport(topElement) == true) {
            bannerComponent.classList.remove('fixed');

            document.documentElement.style.setProperty('--iconMarginTop', '15px');
        }
    }
});